import React, { useState, useEffect } from "react";

import {
  Switch,
  Route,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";

import Header from "./components/Header";

import Home from "./pages/Home";
import ResetPassword from "./pages/PasswordReset";
import Unauthorized from "./pages/Unauthorized";
import Login from "./pages/Login";
import SupportStaff from "./pages/SupportStaff";
import PasswordReset from "./pages/PasswordReset";
import TrainingProviderHome from "./pages/TrainingProviderHome";
import PositionExplorer from "./pages/PositionExplorer";
import SupportDesk from "./pages/SupportDesk";

function Layout() {
  const location = useLocation();
  return (
    <>
      <div>
        {/* <Header /> */}

        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/support-staff" component={SupportStaff} />
          <Route path="/password-reset" component={PasswordReset} />
          <Route path="/unauthorized" component={Unauthorized} />
          <Route path="/training-provider" component={TrainingProviderHome} />
          <Route path="/teacher-vacants" component={PositionExplorer} />
          <Route path="/support-desk" component={SupportDesk} />
          <Route path="/" component={Home} />
        </Switch>
      </div>
    </>
  );
}

export default Layout;
